import template from './retailer-groups-existing-user-field.html';

export default {
  template,
  require: 'ngModel',
  controller: 'RetailerGroupsExistingUserField',
  bindings: {
    form: '=',
    user: '='
  }
}



// WEBPACK FOOTER //
// ./src/modules/retailer-groups/components/existing-user-field/retailer-groups-existing-user-field-component.js